import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { apiFetch, getUserFacingErrorMessage } from './services/apiClient';
import './components/LoginPage.css';

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    if (!token) {
      setError('Missing reset token. Open the link from your email.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const res = await apiFetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(
          getUserFacingErrorMessage(res.status, data, data.detail || 'Reset failed')
        );
        return;
      }
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Reset password</h1>
          <p>Choose a new password for your account.</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        {done ? (
          <div>
            <p style={{ color: 'var(--text-color)' }}>
              Password updated. Redirecting to sign in…
            </p>
            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/login" className="link-btn">
                Sign in now
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="new-password">New password</label>
              <input
                id="new-password"
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
                required
                minLength={8}
                placeholder="At least 8 characters"
                autoComplete="new-password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirm-password">Confirm password</label>
              <input
                id="confirm-password"
                type="password"
                value={confirm}
                onChange={(ev) => setConfirm(ev.target.value)}
                required
                minLength={8}
                placeholder="Re-enter password"
                autoComplete="new-password"
              />
            </div>
            <button type="submit" className="submit-btn" disabled={loading || !token}>
              {loading ? 'Saving…' : 'Update password'}
            </button>
            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/forgot-password" className="link-btn">
                Request a new link
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
